module.exports = __webpack_public_path__ + "static/media/user-guides-image.70ffb92a.jpg";